import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { CollectionView } from '@grapecity/wijmo'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { AllowDragging } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, JobOwnershipRoleEx, JobOwnershipTemplate, JobOwnershipTemplateItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { JobOwnershipTemplateItemComponent } from './job-ownership-template-item.component'
import { JobOwnershipTemplateComponent } from './job-ownership-template.component'

@Component({
    templateUrl: './job-ownership-templates.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class JobOwnershipTemplatesComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<JobOwnershipTemplate>
    itemGrid: Grid<JobOwnershipTemplateItem>
    roleMap = JobOwnershipRoleEx.toDataMap()

    constructor() {
        super()
        this.grid = new Grid<JobOwnershipTemplate>(this.services)
            .setupModalEditing(
                this.services.data.jobOwnershipTemplates,
                'Job Ownership Template',
                JobOwnershipTemplateComponent,
                () => new JobOwnershipTemplate(),
                this,
                ModalSize.small,
            )
            .filterBy(item => [item.name])
        this.itemGrid = new Grid<JobOwnershipTemplateItem>(this.services)
            .setupModalEditing(
                this.services.data.jobOwnershipTemplateItems,
                'Job Ownership Template Item',
                JobOwnershipTemplateItemComponent,
                () => new JobOwnershipTemplateItem(),
                this,
                ModalSize.small,
            )
            .filterBy(item => [item.name])
            .allowDragging(AllowDragging.Both)
            .withColumnFilters()
        const reordered = () => {
            this.itemGridReordered()
        }
        this.itemGrid.dragged.on(reordered)
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.jobOwnershipTemplates.queryAll(),
                    this.services.data.jobOwnershipTemplateItems.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.grid.items = result[0]
                        this.itemGrid.items = result[1]
                        const view = this.itemGrid.view as CollectionView
                        view._filters.push(x => x.jobOwnershipTemplateId === this.grid.selectedItem?.id)
                    },
                }),
        )
    }
    filterItems() {
        this.itemGrid.flexGridFilter?.clear()
        this.itemGrid.filter = ''
    }
    itemGridReordered() {
        const items = this.itemGrid.view.items
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.put('/api/JobOwnershipTemplateItem/BulkUpdate', items)).subscribe({
                next: () => {
                    this.refresh()
                },
            }),
        )
    }
    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.OperationsJobOwnershipTemplatesEdit])
    }
}
